<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="标签批次" prop="LabelBatch">
                <el-input size="small" v-model="model.LabelBatch" auto-complete="off" placeholder="请输入标签批次" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="标签供应商" prop="LableSupplier">
                <el-input size="small" v-model="model.LableSupplier" auto-complete="off" placeholder="请输入供应商" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="标签订单号" prop="BatchOrderNo">
                <el-input size="small" v-model="model.BatchOrderNo" auto-complete="off" placeholder="请输入标签订单号" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateLableBatch,
    } from '../../api/tag'
    import {
        Upload
    } from '../../api/common'
    export default {
        data() {
            return {
                title: '编辑标签',
                name: 'edit',
                labelwidth: '150px',
                labelPosition: 'right',
                baseURL: window.Global.baseURL,
                provinceList: [],
                model: {
                LabelBatch: null,
                LableSupplier: '',
                BatchOrderNo: '',
            },
            rules: {
                LabelBatch: [{ required: true, message: '请输入标签批次', trigger: 'blur' }],
                LableSupplier: [{ required: true,message: '请输入标签供应商', trigger: 'blur'}],
                BatchOrderNo: [{ required: true, message: '请输入标签订单号', trigger: 'blur' }],
            },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            data: {
                required: true,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                if (this.data) {
                    this.model = this.data;
                }
            },
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.UpdateLableBatch()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateLableBatch() {
                UpdateLableBatch({
                    BatchOID:this.model.BatchOID,
                    LabelBatch:this.model.LabelBatch,
                    LableSupplier: this.model.LableSupplier,
                    BatchOrderNo:this.model.BatchOrderNo
                }).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '编辑成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
        }
    }
</script>

<style>

</style>